import { fetchToken } from "../../common/FetchCookie"
import { ADMIN, BASE_URL, DASHBOARD_DATA } from "../../common/URLs"

export const fetchAdminDashboardData = async () => {
    const url = `${BASE_URL}/${ADMIN}/${DASHBOARD_DATA}`
    try {
        const token = await fetchToken();
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Accept': "application/json",
                'Authorization':
                    `Bearer ${token}`,
            },
        })

        const data = await response.json();
        return data;
    } catch (error) {
        console.log("error", error)

    }
}